import { AxiosError } from 'axios';

import { FieldError, FieldsErrorsType } from '../../constants/types/axios.types.ts';

export enum ErrorKeys {
  Network,
  FormValidation,
  ErrorsToSnackbar,
}

class ErrorParser {
  static getAxiosError(res: AxiosError<FieldsErrorsType>): FieldsErrorsType | undefined {
    return res.response?.data;
  }

  static checkIsOtherError(errors: FieldError[]) {
    return errors.every(({ property }) => !property);
  }

  // eslint-disable-next-line consistent-return
  static parseError(res: AxiosError<FieldsErrorsType>, ignoreFormValidation = false) {
    if (!res.response) {
      return { key: ErrorKeys.Network };
    }

    const errorData = ErrorParser.getAxiosError(res);

    if (errorData?.errors?.length) {
      const { errors } = errorData;

      if (ErrorParser.checkIsOtherError(errors) || ignoreFormValidation) {
        return { key: ErrorKeys.ErrorsToSnackbar, errors };
      }

      return { key: ErrorKeys.FormValidation, errors };
    }

    return { key: ErrorKeys.ErrorsToSnackbar, errors: [{ messageKey: 'oops' }] };
  }
}

export default ErrorParser;
